import * as IoC from 'typescript-ioc';
import { JobConfiguration } from '../../job-configuration';
import { JobType } from '../../../../api/jobs.dao';
import { IAttendeesDAO } from '../../../../api/attendees.dao';


export class AccessCodesUploadJob extends JobConfiguration {
    public readonly type = JobType.AccessCodesUpload;
    public readonly name = 'Upload Access Codes';
    public readonly description = 'Access Codes Upload';

    public async execute(execParams) {
        return IoC.Container.get(IAttendeesDAO).importAccessCodes(execParams);
    }
}

export default {
    [JobType.AccessCodesUpload]: AccessCodesUploadJob
};
